import { combineReducers } from 'redux';
import currentUser from './currentUser';
import project from './project';
import userTask from './userTask';

const rootReducer = combineReducers({
  currentUser,
  project,
  userTask
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/